import axios from "axios";

// Create the Axios instance
const API = axios.create({
  baseURL: "/",
  withCredentials: true, // This sends cookies including the refresh token along with every request
  headers: {
    "Content-Type": "application/json",
  },
});

const TOKEN_KEYS = ["operator_token", "admin_token", "patient_token"];


// Request Interceptor: Attach stored access token to every request
API.interceptors.request.use(
  (config) => {
    let token, tokenKeyUsed;
    for (let key of TOKEN_KEYS) {
      token = sessionStorage.getItem(key);
      if (token) {
        tokenKeyUsed = key;
        break;
      }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.tokenKeyUsed = tokenKeyUsed;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Check for a new access token in response headers
API.interceptors.response.use(
  (response) => {
    // When Django middleware returns a new token on token expiration,
    // it adds it to the "Authorization" header in the response.
    const newToken = response.headers["authorization"];
    if (newToken && newToken.startsWith("Bearer ")) {
      const accessToken = newToken.split(" ")[1];
      if (response.config.tokenKeyUsed) {
        sessionStorage.setItem(response.config.tokenKeyUsed, accessToken);
      }
    }
    return response;
  },
  async (error) => {
    // If a 401 error is received, something went wrong (even after trying refresh)
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      TOKEN_KEYS.forEach((key) => sessionStorage.removeItem(key));
      sessionStorage.removeItem('project')
      window.location.href = "/";

      return new Promise(() => { });
    }
    if (error.response && error.response.status === 403) {
      window.location.href = '/403';
    }
    return Promise.reject(error);

  }
);

export default API;
